import React from 'react';
import RegionColumn from '../RegionColumn';

const RegionDisplay = () => {
  const sectors = [
    {
      title: 'Service 211 - Information and Referral Centre of Greater Montréal',
      sections: [
        {
          name: 'Lanaudière',
          sub: "MRC de l'Assomption, MRC les Moulins",
          tel: '211',
          website: 'https://www.211qc.ca/repertoire/lanaudiere',
          imgSrc: '/images/regions/lanaudiere.png',
          altText: 'The Lanaudière sector',
          dataVal: 'lanaudiere',
        },
        {
          name: 'Laurentides',
          sub: "MRC de Deux-Montagnes, MRC Thérèse-De-Blainville, Mirabel ",
          tel: '211',
          website: 'https://www.211qc.ca/repertoire/laurentides',
          imgSrc: '/images/regions/laurentides.png',
          altText: 'The Laurentides sector',
          dataVal: 'laurentides',
        },
        {
          name: 'Laval',
          sub: "Laval",
          tel: '211',
          website: 'https://www.211qc.ca/repertoire/laval',
          imgSrc: '/images/regions/laval.png',
          altText: 'The Laval sector',
          dataVal: 'laval',
        },
        {
          name: 'Montérégie',
          sub: "Agglomération de Longueuil, MRC Roussillon, MRC Vaudreuil-Soulanges, MRC les Jardins-de-Napierville, Sainte-Julie",
          tel: '211',
          website: 'https://www.211qc.ca/repertoire/monteregie',
          imgSrc: '/images/regions/monteregie.png',
          altText: 'The Montérégie sector',
          dataVal: 'monteregie',
        },
        {
          name: 'Montréal',
          sub: "Montréal",
          tel: '211',
          website: 'https://www.211qc.ca/repertoire/montreal',
          imgSrc: '/images/regions/montreal.png',
          altText: 'The Montréal sector',
          dataVal: 'montreal',
        },
        // Ajouter plus de région ici...
      ],
    },
    {
      title: 'Service 211 - Québec and regions',
      sections: [
        {
          name: 'Capitale Nationale',
          tel: '211',
          website: 'https://www.211quebecregions.ca/',
          imgSrc: '/images/regions/capitale_nationale.png',
          altText: 'The Capitale Nationale sector',
          dataVal: 'capitalenationale',
        },
        {
          name: 'Chaudière-Appalaches',
          tel: '211',
          website: 'https://www.211quebecregions.ca/',
          imgSrc: '/images/regions/chaudiere_appalaches.png',
          altText: 'The Chaudière-Appalaches sector',
          dataVal: 'chaudiereappalaches',
        },
        {
          name: 'Côte-Nord',
          tel: '211',
          website: 'https://www.211quebecregions.ca/',
          imgSrc: '/images/regions/Côte-Nord.png',
          altText: 'The Côte-Nord sector',
          dataVal: 'Côte-Nord',
        },
        {
          name: 'MRC de Brome-Missisquoi',
          tel: '211',
          website: 'https://www.211quebecregions.ca/',
          imgSrc: '/images/regions/MRC de Brome-Missisquoi.png',
          altText: 'The MRC de Brome-Missisquoi sector',
          dataVal: 'Brome-Missisquoi',
        },
        {
          name: 'MRC Haute-Yamaska',
          tel: '211',
          website: 'https://www.211quebecregions.ca/',
          imgSrc: '/images/regions/mrc_haute_yamaska.png',
          altText: 'The Nord-du-Québec sector',
          dataVal: 'hauteyamaska',
        },
        // Ajouter plus de région ici...
      ],
    },
  ];

  return (
    <div className="site-centerer">
      <div className="sector-ctn full-width flexbox">
        {sectors.map((sector, index) => (
          <RegionColumn key={index} {...sector} />
        ))}
      </div>
    </div>
  );
};

export default RegionDisplay;
